import type { ProjecaoEscopo } from "@/modules/financeiro-obras";
import { COTACAO_PENDENTE_TITULO } from "../planejamento-controle.constants";
import { formatMoeda } from "../planejamento-controle.format";

type Parte = { valor: number; moeda: string };

export interface CustoPadraoDaLeitura {
  ano: number | null;
  servicos: Parte | null;
  materiais: Parte | null;
  semCotacao: { moeda: string; valor: number }[];
}

export const textoSemCotacao = ({ moeda, valor }: { moeda: string; valor: number }) =>
  `${formatMoeda(valor, moeda)} (${moeda}): ${COTACAO_PENDENTE_TITULO(moeda)}`;

export function custoPadraoDaLeitura(
  projecao: Pick<ProjecaoEscopo, "custoPadrao"> | null,
): CustoPadraoDaLeitura | null {
  const padrao = projecao?.custoPadrao;
  if (!padrao) return null;
  return {
    ano: null,
    servicos: padrao.servicos === null ? null : { valor: padrao.servicos, moeda: "BRL" },
    materiais:
      padrao.materiais !== null && padrao.materiais > 0
        ? { valor: padrao.materiais, moeda: "BRL" }
        : null,
    semCotacao: padrao.semCotacao,
  };
}
